export const SET_WIDGET_TITLE = 'SET_WIDGET_TITLE';
export const SET_BUYERS = 'SET_BUYERS';
export const SET_USER_VISIBLE_COLUMNS = 'SET_USER_VISIBLE_COLUMNS';
export const SET_BUYER_REFERENCES = 'SET_BUYER_REFERENCES';
export const SET_CHECK_REFERENCES_TEXT = 'SET_CHECK_REFERENCES_TEXT';
export const SET_BUYER = 'SET_BUYER';
export const SET_INVITES_FOR_BUYER = 'SET_INVITES_FOR_BUYER';
export const SET_SHOW_NEW_BUYER_INVITES = 'SET_SHOW_NEW_BUYER_INVITES';
